import { EmployeeLicenseUsageComponent } from '../businesses/components/employee-license-usage.component';
import { EmployeeLicenseUpgradeComponent } from '../businesses/components/employee-license-upgrade.component';
import { NgModule } from '@angular/core';
import { AppSharedModule } from './../shared/appShared.module';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UserComponent } from './user.component';
import { UserEditComponent } from './components/userEdit.component';
import { UserFormComponent } from './components/userform.component';
import { UserListComponent } from './components/userList.component';
import { BusinessFeatureService } from './../businesses/services/businessFeatures.service';
import { UserRightsComponent } from './components/userRights.component';
import { UserService } from './services/user.service';
import { PasswordValidatorModule } from 'src/app/shared/password-validator/password-validator.module';
import {
    UserListResolver,
    UserEditResolver,
    UserRoleResolver,
    DeviationUserListResolver
} from './services/user.resolver.service';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { CheckboxModule } from 'primeng/checkbox';

@NgModule({ exports: [
        UserComponent,
        UserListComponent,
        UserRightsComponent,
        UserEditComponent,
        UserFormComponent,
    ],
    declarations: [
        UserComponent,
        UserListComponent,
        UserRightsComponent,
        UserEditComponent,
        UserFormComponent,
    ], imports: [EmployeeLicenseUsageComponent, EmployeeLicenseUpgradeComponent, RouterModule,
        CommonModule,
        AppSharedModule,
        TranslatePipe, TranslateDirective,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        DialogModule,
        TableModule,
        SelectModule,
        ConfirmDialogModule,
        CheckboxModule,
        PasswordValidatorModule
    ],
    providers: [
        UserService,
        BusinessFeatureService,
        UserListResolver,
        UserEditResolver,
        UserRoleResolver,
        DeviationUserListResolver,
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class UserModule { }
